import Marquee from 'react-fast-marquee';
import { Reveal, SectionLabel } from './Reveal';
import { MARQUEE_ITEMS } from '../../data/content';

const points = [
  {
    title: 'Public-sector collaboration',
    text: 'We partner directly with ministries, health authorities and development agencies, aligning delivery with policy and long-term national strategy.',
  },
  {
    title: 'International reach',
    text: 'Structured to operate across jurisdictions, we coordinate cross-border capital, expertise and governance under a single accountable framework.',
  },
  {
    title: 'Institutional trust',
    text: 'Transparent governance and legal rigour make us a dependable counterpart for sovereign and multilateral programmes.',
  },
];

export const Government = () => (
  <section
    id="government"
    data-testid="government-section"
    className="relative border-t border-white/5 bg-navy-900 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <SectionLabel>Government Partnerships</SectionLabel>
          <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
            Trusted counsel to the public sector.
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3">
        {points.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <div className="border-t border-gold/40 pt-6">
              <h3 className="font-serif text-2xl tracking-tight text-white">
                {p.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-slate-300">
                {p.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>

    <div className="mt-20 border-y border-white/10 py-8">
      <Marquee speed={28} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center gap-16 pr-16">
            <span className="font-serif text-3xl italic text-white/40 lg:text-5xl">
              {item}
            </span>
            <span className="text-gold/60 text-2xl">&#9670;</span>
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
